import { createFileRoute, Outlet, redirect } from '@tanstack/react-router';
import { TenantBrandingProvider } from '@/components/providers/tenant-branding-provider';
import { ensureMeQueryData, getMeQueryOptions } from '@/api/me';

const Component = () => {
  return (
    <TenantBrandingProvider>
      <Outlet />
    </TenantBrandingProvider>
  );
};

export const Route = createFileRoute('/_authenticated')({
  beforeLoad: async ({ context, location }) => {
    if (!context.authenticated) {
      throw redirect({
        to: '/login',
        search: {
          redirect: location.href,
        },
      });
    }

    try {
      const user = await context.queryClient.fetchQuery(getMeQueryOptions());
      if (!user) {
        throw new Error('User not found');
      }
    } catch (_error) {
      console.log(_error);
      throw redirect({
        to: '/complete-profile',
      });
    }
  },
  loader: ensureMeQueryData,
  component: Component,
});
